<div class="row" *ngIf="companyDetailsModel">
    <div class="col d-flex">
        <app-company-users-add [companyId]="companyId" (companyUserAdded)="companyUserAdded($event);"
            *ngIf="users?.length<companyDetailsModel.usersNr"></app-company-users-add>
        <div class="p-2 text-primary float-left">{{users?.length}} of {{companyDetailsModel.usersNr}} users assigned</div>
    </div>
</div>
<div class="row mt-5" *ngIf="isUserAddMode">
    <div class="col-12">
        <header class="panel-heading">
            <h5 class="panel-title text-primary">Add New User</h5>
        </header>
    </div>
    <div class="col-12">
        <app-company-users-add [companyId]="companyId"
            (companyUserAdded)="companyUserAdded($event);"></app-company-users-add>
    </div>
</div>
<div class="row mt-5" *ngIf="users?.length==0 && !isUserAddMode">
    <div class="col col-md-6">
        <header class="panel-heading">
            <h5 class="panel-title text-primary">No Existing Users</h5>
        </header>
    </div>
</div>
<div class="row mt-5" *ngIf="users?.length>0 && !isUserAddMode">
    <div class="col col-md-6">
        <header class="panel-heading">
            <h5 class="panel-title text-primary">{{companyDetailsModel?.legalName}} Existing Users</h5>
        </header>
    </div>
    <div class="col col-md-6">
        <div class="row align-items-center">
            <div class="col col-md-2 text-end">
                <label class=" control-label">Filter:</label>
            </div>
            <div class="col-md-10">
                <form [formGroup]="filterForm" *ngIf="filterForm">
                    <input type="text" class="form-control filter-input" formControlName="filterText"
                        placeholder="Start typing to filter list" />
                </form>
            </div>
        </div>
    </div>
</div>

<div class="table-responsive mt-5" *ngIf="users?.length>0 && !isUserAddMode">
    <table class="table table-hover mb-none">
        <thead>
            <tr>
                <th>#</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Type</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody *ngIf="users">
            <tr *ngFor="let u of userList; index as i">
                <td>{{i+1}}</td>
                <td>{{u.firstName}} {{u.id}}</td>
                <td>{{u.lastName}}</td>
                <td>{{u.email}}</td>
                <td>
                    <ng-container *ngIf="!isEditMode">{{u.userTypeDescription}}</ng-container>
                    <ng-container *ngIf="isEditMode">
                        <select name="userTypeId{{i}}" class="form-select"
                            (change)="updateCompanyUserType(u, $event.target.value)">
                            <option *ngFor="let userType of userTypes" [value]="userType.id"
                                [selected]="u.userTypeId==userType.id">{{ userType.description}}</option>
                        </select>
                    </ng-container>
                </td>
                <td class="actions">
                    <a (click)="selectedUserId=u.companyUserId; confirmation.showMessage();"
                        *ngIf="isEditMode && u.siteUserId!=user.id"><i class="fa fa-trash"></i></a>
                </td>
            </tr>
        </tbody>
    </table>
    <!--<pre>{{userList | json}}</pre>-->
</div>
<footer class="panel-footer mt-3">
    <div class="row">
        <div class="col-sm-6">
            <p class="mb-1 mt-1 me-2 text-success" *ngIf="showUpdated"><i class="fas fa-check"></i> Updated</p>
        </div>
        <div class="col-sm-6 text-end">
            <button class="btn btn-primary" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
            <button class="btn btn-outline-primary me-1" type="button" (click)="toggleEditMode()"
                *ngIf="isEditMode">Cancel</button>
        </div>
    </div>
</footer>


<app-confirmation-message #confirmation (confirmationClicked)="deleteUser();" [title]="'Confirmation'"
    [message]="'Are you sure you want to remove this user?'">
</app-confirmation-message>
